module.exports = __webpack_public_path__ + "static/media/sort-shapes-up.c3e91ad2.svg";